var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11V9H7C6.44772 9 6 9.44772 6 10V18H19V16H16.5C15.1193 16 14 14.8807 14 13.5C14 12.1193 15.1193 11 16.5 11H19ZM19.5727 7.08321C20.3982 7.3295 21 8.09447 21 9V18C21 19.1046 20.1046 20 19 20H6C4.89543 20 4 19.1046 4 18V7C4 5.34315 5.34315 4 7 4H18.0727C18.9012 4 19.5727 4.67157 19.5727 5.5V7.08321ZM17.5727 7V6H7C6.44772 6 6 6.44772 6 7V7.17071C6.31278 7.06015 6.64936 7 7 7H17.5727ZM19 13H16.5C16.2239 13 16 13.2239 16 13.5C16 13.7761 16.2239 14 16.5 14H19V13Z",
    fill: "currentColor"
  })));
};
export default SvgWallet;